import * as tslib_1 from "tslib";
import { IgrTemplateCellInfo } from "./igr-template-cell-info";
import { TemplateHeaderCellModel as TemplateHeaderCellModel_internal } from "./TemplateHeaderCellModel";
import { ensureBool } from "igniteui-react-core";
/**
 * Backing information for the template header cells.
*/
var IgrTemplateHeaderCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTemplateHeaderCellInfo, _super);
    function IgrTemplateHeaderCellInfo() {
        return _super.call(this) || this;
    }
    IgrTemplateHeaderCellInfo.prototype.createImplementation = function () {
        return new TemplateHeaderCellModel_internal();
    };
    Object.defineProperty(IgrTemplateHeaderCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTemplateHeaderCellInfo.prototype, "isFilterUIVisible", {
        /**
         * Sets or gets whether the filter UI should be visible in the header.
        */
        get: function () {
            return this.i.k1;
        },
        set: function (v) {
            this.i.k1 = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrTemplateHeaderCellInfo;
}(IgrTemplateCellInfo));
export { IgrTemplateHeaderCellInfo };
//# sourceMappingURL=igr-template-header-cell-info.js.map
